import request from '@/config/axios'

/** 景区商家账号绑定（P0：商家登录后按绑定商家过滤景区数据） */
export const bindScenicMerchantAccount = (accountId: number, merchantId: number, shopId?: number) =>
  request.post({
    url: '/scenic/merchant-account/bind',
    params: { accountId, merchantId, shopId },
    custom: { showSuccess: true }
  })

export const getScenicMerchantAccountList = (merchantId: number) =>
  request.get({ url: '/scenic/merchant-account/list', params: { merchantId } })

/** 景区商家下拉选项（sys_merchant） */
export const getScenicMerchantOptions = (merchantType?: number) =>
  request.get<Array<{ id: number; name: string; code: string; merchantType?: number }>>({
    url: '/scenic/merchant-account/merchant-options',
    params: { merchantType }
  })
